import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { I18nModule, UrlModule } from '@spartacus/core';
import { CardModule, FormErrorsModule, IconModule, KeyboardFocusModule, SplitViewModule } from '@spartacus/storefront';
import { UigCardModule } from '../../card/uig-card.module';
import { UigUserChangePasswordFormComponent } from './uig-user-change-password-form.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    NgSelectModule,
    UrlModule,
    I18nModule,
    CardModule,
    IconModule,
    SplitViewModule,
    ReactiveFormsModule,
    FormErrorsModule,
    KeyboardFocusModule,
  ],
  declarations: [UigUserChangePasswordFormComponent],
})
export class UigUserChangePasswordFormModule {}